const state = {
  request : { page : 1, perPage : 10 }
};

const getters = {
  requestPagination : state => state.request
};

const mutations = {
  SET_PAGINATION : (state, { model, pagination }) => {

    state[model] = pagination;
  }
};

const actions = {
  updatePagination({ commit }, { model, pagination }) {

    commit('SET_PAGINATION', { model, pagination });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
